import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Logo } from "../components/site/Logo";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.role !== "admin") {
        await api.post("/auth/logout");
        setError("This account is not an admin account. Use the regular sign in page.");
        return;
      }
      window.location.assign("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--forest)] px-5">
      <title>Admin sign in | Vata Infrastructures</title>
      <meta name="robots" content="noindex" />
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-[var(--paper)] p-8">
        <Logo />
        <h1 className="mt-8 font-display text-3xl font-extrabold uppercase">Admin sign in</h1>
        <div className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="ad-email">Email</Label>
            <Input id="ad-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="rounded-none bg-white" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="ad-pass">Password</Label>
            <Input id="ad-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="rounded-none bg-white" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-700">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="btn-rust flex w-full items-center justify-center gap-2 py-3 disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
        </div>
      </form>
    </main>
  );
}
